exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-7ef5927b] {\n  font-size: 11px;\n}\n.fa-stack[data-v-7ef5927b] {\n  font-size: 11px;\n}\n.fa-backward[data-v-7ef5927b]::before {\n  margin-left: -5px;\n}\n", ""]);

// exports
